/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_OwedInputs */

const vi_customer_debt_ledger_owed = /** @type {(inputs: Customer_Debt_Ledger_OwedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách nợ`)
};

/**

* @param {Customer_Debt_Ledger_OwedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_owed = /** @type {((inputs?: Customer_Debt_Ledger_OwedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_OwedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_owed(inputs)
});